import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import { useParams } from "react-router-dom";
import { getPostsById } from "../../../../../redux/posts/action";
import { useDispatch, useSelector } from "react-redux";
import ManageAppliedJobDetails from "./ManageAppliedJobDetails";
import ManageAppliedJobProposal from "./ManageAppliedJobProposal";
import ManageAppliedJobOffers from "./ManageAppliedJobOffers";
import { useRouteBaseStateContext } from "../../../../../Context/RouteBaseStateContext";
import PostNotFound from "../../../../CustomComponents/AllLoader/PostNotFound";

export default function ManageAppliedJobTabs() {
  const { urlstate, setManageAppliedjobroute } = useRouteBaseStateContext();
  const { id } = useParams();
  const path = "Assets/scss/FindWork.module.scss";
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("JobDetails"); // State to manage active tab
  const [pd, setPd] = useState(null); // State to manage proposal details

  const posts = useSelector(({ posts: { postbyid } }) => postbyid);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    dispatch(getPostsById(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (posts?.my_proposal && posts.my_proposal.length > 0) {
      setPd(posts.my_proposal[0]);
    }
    else if (posts.my_proposal_declined && posts.my_proposal_declined.length > 0) {
      setPd(posts.my_proposal_declined[0]);
    } else {
      setPd(null);
    }
  }, [posts]);

  useEffect(() => {
    if (urlstate?.manageappliedjobroute) {
      setActiveTab(urlstate?.manageappliedjobroute || "JobDetails");
    } else {
      setActiveTab("JobDetails");
    }
  }, [urlstate, urlstate?.manageappliedjobroute]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setManageAppliedjobroute(tab);
  };

  console.log(posts.price2, 'posts.price2', posts.price, 'posts.price');

  return (
    <div className="project-section">
      <h4>{posts?.title}</h4>
      <div className="col-12 mob-pad">
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab == "JobDetails" ? "active" : ""}`}
              onClick={() => handleTabClick("JobDetails")}
            >
              Job Details
            </a>
          </li>
          {posts && <li className="nav-item">
            <a
              className={`nav-link ${activeTab == "MyProposal" ? "active" : ""}`}
              onClick={() => handleTabClick("MyProposal")}
            >
              My Proposal
            </a>
          </li>}
          {/* {pd?.status == 23 &&  ( */}
          {
            pd?.payment_status == 0 ? <></> :
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab == "Offers" ? "active" : ""}`}
                  onClick={() => handleTabClick("Offers")}
                >
                  Offers
                </a>
              </li>
          }
          {/* )} */}
        </ul>
        <div className="tab-content">
          <div
            className={`tab-pane ${activeTab == "JobDetails" ? "active" : ""}`}
            id="JobDetails"
          >
            <ManageAppliedJobDetails posts={posts} />
          </div>
          <div
            className={`tab-pane ${activeTab == "MyProposal" ? "active" : ""}`}
            id="MyProposal"
          >
            <ManageAppliedJobProposal pd={pd} posts={posts} />
          </div>
          {/* {pd?.status == 23 && pd?.payment_status == 1 ? ( */}
          <div
            className={`tab-pane ${activeTab == "Offers" ? "active" : ""}`}
            id="Offers"
          >
            <ManageAppliedJobOffers pd={pd} posts={posts} />
          </div>
          {/* ) */}
          {/* // : <PostNotFound title="No offer yet" height={200} />} */}
        </div>
      </div>
    </div>
  );
}
